import { Col } from "react-bootstrap";

import { DollarIcon, MoreInfoIcon } from "../../../assets/icons/iconsProvider";
import {
  categoryDropdownConstants,
  EMPTY_STRING,
  inventoryConstants,
  toggleSwitchButtonConstants,
} from "../../../constants";
import {
  getMarginDropdownValue,
  getProductSubCategory,
  handleBeautifyMarketPrice,
  isMarketPriceHigh,
  isShopifyConnected,
  isShopifyConnectedForProduct,
  isSystemProduct,
  onChangeStockPrice,
} from "../../utility";
import InputNumberField from "../inputNumberField/InputNumberField";
import CategoriesDropdown from "../selectDropdown/CategoriesDropdown";
import ToggleButtonWithText from "../toggleButtons/ToggleButtonWithText";
import OnlineQuantity from "./OnlineQuantity";
import Quantity from "./Quantity";

const AddInventoryProductPrices = ({
  isBatchEdit = false,
  values,
  productTags,
  productType,
  selectedTags,
  initialRatio,
  currentStore,
  setFieldValue,
  markupPresets,
  tradeinMargin,
  marginTypeObject,
  productCondition,
  productDataObject,
  handleMarginChange,
  setMarginTypeObject,
  handleCashOfferValues,
  handleTradeOfferValues,
  priceChartingProductInfo,
  productUrl,
  isTradeInProduct = false,
}) => {
  const handleToggleOnlineQuantity = (value) => {
    setFieldValue("isSeparateQuantity", value);
  };
  const productMetaData = priceChartingProductInfo.productMetaData
    ? priceChartingProductInfo.productMetaData
    : priceChartingProductInfo;

  //------- isShopifyConnected
  const isShopifyStoreConnected = isShopifyConnected(currentStore);
  const isLinkToShopify = isShopifyConnectedForProduct(
    currentStore,
    productDataObject.isLinkToShopify
  );
  const isOnlineValues = isLinkToShopify && values?.isSeparateQuantity;

  return (
    <>
      {/* <Col xs={12} className="d-flex flex-column gap-1 mb-3">
        <div className="w-100 d-flex justify-content-between add-inventory-price-sub-heading">
          <span>Suggested sell price: </span>
          <span>
            {`$${parseToThousandSeperatorDecimalNumber(
              convertToUsd(productDataObject?.suggestedSellPrice || 0)
            )}`}
          </span>
        </div>
        <div className="w-100 d-flex justify-content-between add-inventory-price-sub-heading">
          <span>In-Stock Price: </span>
          <span>
            {`$${parseToThousandSeperatorDecimalNumber(
              productDataObject?.inStorePrice || 0
            )}`}
          </span>
        </div>
      </Col> */}
      <Col xs={6} className="d-flex flex-column gap-3 pe-0">
        <div className="add-inventory-stock-price-wrapper h-100">
          <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-sub-heading mb-3">
            <span className="d-flex align-items-center gap-2">
              Stock Price
              <span>
                <MoreInfoIcon className={"more-info-icon"} />
              </span>
            </span>

            {/* {isLinkToShopify && (
              <CheckboxField
                name={"isOnlineUnitSellPrice"}
                label="Different Online Price"
                isLabelLeft={true}
              />
            )} */}
          </div>
          <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-heading mb-2">
            <span>In-Store </span>
            <InputNumberField
              name="inStockPrice"
              placeHolder="0.00"
              className={`add-inventory-price-field ${
                productUrl
                  ? "instore-price-field-reduced-width"
                  : "instore-price-field"
              }  ${
                isMarketPriceHigh(
                  handleBeautifyMarketPrice(productDataObject),
                  values.inStockPrice,
                  productTags,
                  selectedTags
                ) && values.inStockPrice
                  ? "border-danger"
                  : ""
              }`}
              handleChange={(newValue) => {
                let marketPrice = handleBeautifyMarketPrice(
                  productDataObject,
                  false,
                  isBatchEdit
                );
                onChangeStockPrice(
                  newValue,
                  setFieldValue,
                  marketPrice,
                  "",
                  marginTypeObject,
                  currentStore,
                  isTradeInProduct ? "cashOffer" : "costOfGoods",
                  markupPresets,
                  productType,
                  productDataObject,
                  values.isOnlineUnitSellPrice
                );
              }}
              IconImage={DollarIcon}
            />
          </div>
          {isLinkToShopify && (
            <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-heading">
              <span>Online </span>
              <InputNumberField
                name="onlineUnitSellPrice"
                placeHolder="0.00"
                className={`add-inventory-price-field ${
                  productUrl
                    ? "instore-price-field-reduced-width"
                    : "instore-price-field"
                }`}
                handleChange={(newValue) => {
                  let marketPrice = handleBeautifyMarketPrice(
                    productDataObject,
                    false,
                    isBatchEdit
                  );
                  onChangeStockPrice(
                    newValue,
                    setFieldValue,
                    marketPrice,
                    "",
                    marginTypeObject,
                    currentStore,
                    "onlineUnitPurchasePrice",
                    markupPresets,
                    productType,
                    productDataObject,
                    true,
                    true
                  );
                }}
                IconImage={DollarIcon}
              />
            </div>
          )}
        </div>
      </Col>
      <Col xs={6} className="d-flex flex-column gap-3 pe-0">
        <div className="add-inventory-stock-price-wrapper h-100">
          <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-sub-heading mb-3">
            <span className="d-flex align-items-center gap-2">
              Quantity
              <span>
                <MoreInfoIcon className={"more-info-icon"} />
              </span>
            </span>
            {isLinkToShopify && values.isOnlineQuantity && (
              <ToggleButtonWithText
                isToggle={values.isSeparateQuantity}
                handleLeftButtonClick={() => {
                  handleToggleOnlineQuantity(false);
                }}
                handleRightButtonClick={() => {
                  handleToggleOnlineQuantity(true);
                }}
                leftButtonLabel="In-Store"
                rightButtonLabel="Online"
                className={
                  "discount-toggle-button " +
                  (productUrl
                    ? "add-inventory-quantity-toggle-switch-reduced-width"
                    : "add-inventory-quantity-toggle-switch")
                }
                isDisabled={
                  isSystemProduct(
                    getProductSubCategory(productMetaData?.genre)
                  ) &&
                  currentStore[
                    toggleSwitchButtonConstants
                      .IS_SERIAL_NUMBER_REQUIRED_INVENTORY
                  ]
                }
              />
            )}
          </div>
          <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-heading mb-3">
            <span>Current Stock :</span>
            <span>{`${
              isOnlineValues
                ? productDataObject.onlineInStockQuantity ||
                  values?.onlineInStockQuantity ||
                  0
                : isBatchEdit
                ? productDataObject.inStoreQuantity || 0
                : productDataObject.inStockQuantity || 0
            }`}</span>
          </div>
          <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-heading mb-2">
            <span>{"Units To Add"}</span>
            {isOnlineValues ? (
              <OnlineQuantity
                currentStore={currentStore}
                priceChartingProductInfo={priceChartingProductInfo}
                productUrl={productUrl}
              />
            ) : (
              <Quantity
                currentStore={currentStore}
                priceChartingProductInfo={priceChartingProductInfo}
                productUrl={productUrl}
              />
            )}
          </div>
        </div>
      </Col>
      {isTradeInProduct ? (
        <Col xs={12} className="d-flex flex-column gap-3 mb-4 pe-0 mt-3">
          <div className="add-inventory-stock-price-wrapper">
            <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-sub-heading mb-3">
              <span className="d-flex align-items-center gap-2">
                Margin
                <span>
                  <MoreInfoIcon className={"more-info-icon"} />
                </span>
              </span>
              <CategoriesDropdown
                options={[
                  inventoryConstants.MARGIN_TYPE_GLOBAL,
                  inventoryConstants.MARGIN_TYPE_STANDARD,
                ]}
                disabled={
                  getMarginDropdownValue(
                    handleBeautifyMarketPrice(
                      productDataObject,
                      false,
                      isBatchEdit
                    ),
                    tradeinMargin,
                    productType,
                    {
                      ...productDataObject,
                      tags: selectedTags,
                      condition: productCondition?.value,
                      cardRarity: productDataObject.cardRarity || EMPTY_STRING,
                      subcategory: getProductSubCategory(
                        productDataObject.genre
                      ),
                    }
                  )?.marginType === inventoryConstants.MARGIN_TYPE_GLOBAL
                }
                handleChange={(selectedOption) =>
                  handleMarginChange(
                    handleBeautifyMarketPrice(
                      productDataObject,
                      false,
                      isBatchEdit
                    ),
                    productType,
                    setFieldValue,
                    selectedOption,
                    tradeinMargin,
                    productDataObject,
                    setMarginTypeObject
                  )
                }
                noOptionsMessage="No Condition Found"
                placeholder="Global"
                SelectIconImage={categoryDropdownConstants.INVENTORY_LIST_ICON}
                isClearable={false}
                // defaultValue={marginTypeObject}
                className="add-inventory-dropdowns-category condition-dropdown remove-minWidth-dropdown"
                value={marginTypeObject?.marginType}
              />
            </div>
            <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-heading mb-2">
              <span>Cash Offer </span>
              <InputNumberField
                name={isOnlineValues ? "onlineCashOffer" : "cashOffer"}
                placeHolder="0"
                className="add-inventory-price-field input-background instore-price-field"
                IconImage={DollarIcon}
                handleChange={(value) => {
                  isOnlineValues
                    ? handleCashOfferValues(
                        value,
                        setFieldValue,
                        initialRatio,
                        true
                      )
                    : handleCashOfferValues(
                        value,
                        setFieldValue,
                        initialRatio,
                        false
                      );
                }}
              />
            </div>{" "}
            <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-heading mb-2">
              <span>Trade Offer </span>
              <InputNumberField
                name={isOnlineValues ? "onlineTradeOffer" : "tradeOffer"}
                placeHolder="0"
                className="add-inventory-price-field input-background instore-price-field"
                IconImage={DollarIcon}
                handleChange={(value) => {
                  isOnlineValues
                    ? handleTradeOfferValues(
                        value,
                        setFieldValue,
                        initialRatio,
                        true
                      )
                    : handleTradeOfferValues(
                        value,
                        setFieldValue,
                        initialRatio,
                        false
                      );
                }}
              />
            </div>
          </div>
        </Col>
      ) : (
        <Col xs={12} className="d-flex flex-column gap-3 mb-4 pe-0 mt-3">
          <div className="add-inventory-stock-price-wrapper">
            <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-sub-heading mb-3">
              <span className="d-flex align-items-center gap-2">
                Cost of Goods
                <span>
                  <MoreInfoIcon className={"more-info-icon"} />
                </span>
              </span>
            </div>
            <div className="w-100 d-flex justify-content-between align-items-center add-inventory-price-heading mb-2">
              <span>{isOnlineValues ? "Online Cogs" : "Cogs"}</span>
              <InputNumberField
                name={
                  isOnlineValues ? "onlineUnitPurchasePrice" : "costOfGoods"
                }
                placeHolder="0.00"
                className="add-inventory-price-field instore-price-field"
                IconImage={DollarIcon}
              />
            </div>
          </div>
        </Col>
      )}
    </>
  );
};

export default AddInventoryProductPrices;
